import React from "react";
import { connect } from "react-redux";

import NextGenVisitsToProcess from "./NextGenVisitsToProcess";

const NextGenVisitsToProcessContainer = props => {
  return <NextGenVisitsToProcess {...props} />;
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(NextGenVisitsToProcessContainer);



// WEBPACK FOOTER //
// src/pages/NextGenDashboard/NextGenVisitsToProcess.container.js